import { useState } from "react";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { apiClient } from "@/lib/apiClient";
import { toast } from "sonner";

interface Props {
  /** Caminho do endpoint de sync, ex.: /api/cadastros/fiscal/sacfiscal/sincronizar/cclasstrib */
  endpoint: string;
  label?: string;
  onDone?: () => void;
}

/** Botão padrão para sincronizar uma tabela a partir da SACFiscal.IO. */
export function SacFiscalSyncButton({ endpoint, label = "Sincronizar SACFiscal", onDone }: Props) {
  const [loading, setLoading] = useState(false);

  const run = async () => {
    setLoading(true);
    try {
      const { data } = await apiClient.post(endpoint);
      toast.success(`Sincronizado da SACFiscal: ${data.inseridos} novos, ${data.atualizados} atualizados.`);
      onDone?.();
    } catch {
      toast.error("Falha ao sincronizar com a SACFiscal (verifique a chave em configuração).");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button variant="outline" onClick={run} disabled={loading}>
      <RefreshCw className={`h-4 w-4 mr-2 ${loading ? "animate-spin" : ""}`} />
      {loading ? "Sincronizando..." : label}
    </Button>
  );
}
